// SIWS CUSTOM: 250th Anniversary Hat — Limited Run picker (2026-05-27).
//
// Two variants only: Black/Black Mesh Snapback + Gray/White Mesh Snapback,
// both $20. Per-variant qty stepper snaps to multiples of 3 (matches the
// per-color min/step convention from duck-camo-hats-picker). Combined cart
// minimum is 12 across both variants AND the combined total must be a
// multiple of 12 (so dealers hit price-tier breakpoints cleanly: 12, 24,
// 36, 48, 60, ...). PDP-side tier preview is fixed-total math (12=$240,
// 24=$430, 48=$775) — matches the assorted-hats display values; actual
// cart-side discounts apply via the existing Assorted Hat Pack 24+ / 48+
// admin discount records (scoped to also include this product).
//
// ATC payload uses one items[] entry per variant (duck-camo-hats pattern),
// since the product has two real Shopify variants. Cart-locked treatment
// applies cart-side via assets/cart.js SIWS_LOCKED_PRODUCTS title match.

(function () {
  'use strict';

  // SIWS CUSTOM: per-variant snap unit + per-variant floor (must be 0 OR ≥ 3).
  // Combined min + combined step BOTH apply at the aggregate level — dealers
  // can split 12 as 6+6, 9+3, 12+0, etc.; can split 24 as 12+12, 18+6, etc.
  var SIWS_ANNIV_STEP        = 3;
  var SIWS_ANNIV_VARIANT_MIN = 3;
  var SIWS_ANNIV_AGG_MIN     = 12;
  var SIWS_ANNIV_AGG_STEP    = 12;

  // SIWS CUSTOM: Fixed-total tier prices for the PDP preview. Mirrors the
  // calcPrice() math in assorted-hats-product.liquid — 48+ extrapolates the
  // per-12 rate from the 48-pack price ($775 / 4 = $193.75 per 12 above 48).
  function siwsAnnivCalcPrice(qty) {
    if (qty <= 0) return 0;
    if (qty >= 48) return 775 + ((qty - 48) / 12) * (775 / 4);
    if (qty >= 24) return (430 / 24) * qty;
    return 20 * qty; // qty in [12, 23]
  }

  // SIWS CUSTOM 2026-05-27 PDP polish round 4 — thumb-click trigger + tier-aware
  // per-line summary math: shared tier-band helper. Both _renderTierCallout and
  // _renderSummary now consume this so per-line and total math stay consistent.
  // Below 12 the rate is the base $20 (tier hasn't qualified); 12-23 still $20;
  // 24-47 hits $17.916…; 48+ hits $16.145… Returns the per-each raw float;
  // siwsAnnivFmt() handles display rounding.
  function siwsAnnivPerEachFor(totalQty) {
    if (totalQty >= 48) return 775 / 48;
    if (totalQty >= 24) return 430 / 24;
    return 20;
  }

  // SIWS CUSTOM: $-format with no trailing .00 on whole dollars.
  function siwsAnnivFmt(amount) {
    var opts = amount % 1 === 0
      ? { minimumFractionDigits: 0, maximumFractionDigits: 0 }
      : { minimumFractionDigits: 2, maximumFractionDigits: 2 };
    return '$' + amount.toLocaleString('en-US', opts);
  }

  function SIWSAnnivHatPicker(el) {
    this.el = el;
    this.colorQtys = {};   // { variantId: qty }
    this.cartHatQty = 0;   // existing in-cart 250th anniversary hats
    this.cartHatQtyByVariant = {}; // { variantId(string): qty already in cart }
    this.pickerQty = 0;
    this.totalQty  = 0;
    this._init();
  }

  SIWSAnnivHatPicker.prototype._init = function () {
    this._qtyGrid      = this.el.querySelector('#siws-anniv-hat-variant-grid');
    this._summaryEl    = this.el.querySelector('#siws-anniv-hat-summary');
    this._atcBtn       = this.el.querySelector('#siws-anniv-hat-atc-btn');
    this._msgEl        = this.el.querySelector('#siws-anniv-hat-message');
    // SIWS CUSTOM 2026-05-27 PDP polish round 2 — Duck Camo pattern parity:
    // tier-progress callout replaces the prior tier-message div.
    this._tierCalloutEl = this.el.querySelector('#siws-anniv-hat-tier-callout');
    // SIWS CUSTOM 2026-05-27 PDP polish round 3 — Duck Camo full pattern parity:
    // hero img reference for the swap-on-interaction behavior. Mirrors
    // duck-camo-hats _bindSwatches heroEl reference.
    this._heroImg = this.el.querySelector('.siws-anniv-hat__hero');

    this._bindQtyPicker();
    this._bindAtc();
    this._update();

    // SIWS CUSTOM: cart-aware tier preview. Same pattern as
    // duck-camo-hats-picker._fetchCartCamoQty — match by product TITLE so
    // dealers viewing the PDP see the right tier if they already have hats
    // in cart from a prior add.
    this._fetchCartHatQty();
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      var self = this;
      subscribe(PUB_SUB_EVENTS.cartUpdate, function () { self._fetchCartHatQty(); });
    }
  };

  SIWSAnnivHatPicker.prototype._fetchCartHatQty = function () {
    var self = this;
    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : { items: [] }; })
      .then(function (cart) {
        var hats = (cart.items || []).filter(function (i) {
          return i.title && i.title.indexOf('250th Anniversary Hat') !== -1;
        });
        self.cartHatQty = hats.reduce(function (s, i) { return s + i.quantity; }, 0);
        var byVariant = {};
        hats.forEach(function (i) {
          var k = String(i.variant_id);
          byVariant[k] = (byVariant[k] || 0) + i.quantity;
        });
        self.cartHatQtyByVariant = byVariant;
        self._update();
      })
      .catch(function () { /* graceful — keep last known value */ });
  };

  // ── Qty picker grid (2 cards, one per variant) ─────────────
  SIWSAnnivHatPicker.prototype._bindQtyPicker = function () {
    if (!this._qtyGrid) return;
    var self = this;

    this._qtyGrid.addEventListener('click', function (e) {
      // SIWS CUSTOM 2026-05-27 PDP polish round 4 — thumb-click trigger:
      // wrapping <button> around the variant thumb fires _selectCard on
      // click. No stepper delta — clicking the thumb only selects the
      // variant + swaps the hero; qty changes still come from +/−.
      var thumbBtn = e.target.closest('.siws-anniv-hat__variant-card-button');
      if (thumbBtn) self._selectCard(thumbBtn.dataset.variantId);

      var minusBtn = e.target.closest('.siws-anniv-hat__qty-minus');
      var plusBtn  = e.target.closest('.siws-anniv-hat__qty-plus');
      if (minusBtn) {
        self._selectCard(minusBtn.dataset.variantId);
        self._stepQty(minusBtn.dataset.variantId, -SIWS_ANNIV_STEP);
      }
      if (plusBtn) {
        self._selectCard(plusBtn.dataset.variantId);
        self._stepQty(plusBtn.dataset.variantId, +SIWS_ANNIV_STEP);
      }
    });

    // Track raw value during typing so the live total reacts; snap on blur.
    this._qtyGrid.addEventListener('input', function (e) {
      var inp = e.target.closest('.siws-anniv-hat__qty-input');
      if (!inp) return;
      self._selectCard(inp.dataset.variantId);
      var raw = parseInt(inp.value, 10);
      self.colorQtys[inp.dataset.variantId] = (raw > 0) ? raw : 0;
      self._update();
    });

    // SIWS CUSTOM 2026-05-27 PDP polish round 2 — Duck Camo pattern parity:
    // focusin delegation (focus doesn't bubble). Selects the variant card
    // the dealer tabs/clicks into, even before they type.
    this._qtyGrid.addEventListener('focusin', function (e) {
      var inp = e.target.closest('.siws-anniv-hat__qty-input');
      if (!inp) return;
      self._selectCard(inp.dataset.variantId);
    });

    // Capture-phase blur (blur doesn't bubble).
    this._qtyGrid.addEventListener('blur', function (e) {
      var inp = e.target.closest('.siws-anniv-hat__qty-input');
      if (!inp) return;
      self._validateAndSnap(inp);
    }, true);
  };

  // SIWS CUSTOM 2026-05-27 PDP polish round 2 + round 3 — Duck Camo pattern parity:
  // Toggle the .is-selected class on the card matching the given variantId,
  // AND swap the big left hero img src to that variant's full-size image.
  // Both behaviors fire together — same trigger surface (focusin / +-/− click
  // / input typing) drives both card-border highlight and hero swap. Hero
  // fade mirrors assets/duck-camo-hats-picker.js _bindSwatches verbatim:
  // preloaded Image + is-swapping opacity toggle + requestAnimationFrame.
  SIWSAnnivHatPicker.prototype._selectCard = function (variantId) {
    if (!this._qtyGrid) return;
    var matchedCard = null;
    var cards = this._qtyGrid.querySelectorAll('.siws-anniv-hat__variant-card');
    for (var i = 0; i < cards.length; i++) {
      var card = cards[i];
      if (card.dataset.variantId === variantId) {
        card.classList.add('is-selected');
        matchedCard = card;
      } else {
        card.classList.remove('is-selected');
      }
    }
    // Hero swap — only if we have a hero img + a matched card + an image URL
    // that differs from the current hero src. Same defensive shape as the
    // duck-camo-hats canonical.
    if (!this._heroImg || !matchedCard) return;
    var newSrc = matchedCard.dataset.variantImage;
    if (!newSrc || this._heroImg.getAttribute('src') === newSrc) return;
    var heroEl = this._heroImg;
    var labelEl = matchedCard.querySelector('.siws-anniv-hat__variant-label');
    var altText = labelEl ? labelEl.textContent : '';
    heroEl.classList.add('is-swapping');
    var tmp = new Image();
    tmp.onload = function () {
      heroEl.setAttribute('src', newSrc);
      if (altText) heroEl.setAttribute('alt', altText);
      requestAnimationFrame(function () {
        heroEl.classList.remove('is-swapping');
      });
    };
    tmp.onerror = function () { heroEl.classList.remove('is-swapping'); };
    tmp.src = newSrc;
  };

  SIWSAnnivHatPicker.prototype._stepQty = function (variantId, delta) {
    var current = this.colorQtys[variantId] || 0;
    var next    = Math.max(0, current + delta);
    this.colorQtys[variantId] = next;
    var inp = this._qtyGrid.querySelector(
      '.siws-anniv-hat__qty-input[data-variant-id="' + variantId + '"]'
    );
    if (inp) {
      inp.value       = next > 0 ? String(next) : '';
      inp.placeholder = '0';
    }
    this._clearMessage();
    this._update();
  };

  // SIWS CUSTOM: Snap UP (Math.ceil) per duck-camo-hats convention. 5 → 6,
  // 7 → 9, 13 → 15. Per-variant floor is 3 if non-zero; ceil-to-step handles
  // multiples-of-3.
  SIWSAnnivHatPicker.prototype._validateAndSnap = function (inp) {
    var variantId = inp.dataset.variantId;
    var raw = parseInt(inp.value, 10);

    if (isNaN(raw) || raw <= 0) {
      this.colorQtys[variantId] = 0;
      inp.value       = '';
      inp.placeholder = '0';
      this._update();
      return;
    }

    var snapped = Math.max(
      SIWS_ANNIV_VARIANT_MIN,
      Math.ceil(raw / SIWS_ANNIV_STEP) * SIWS_ANNIV_STEP
    );

    if (snapped !== raw) {
      var variantTitle = inp.dataset.variantTitle || 'this color';
      this._showMessage(
        'Quantities must be in multiples of ' + SIWS_ANNIV_STEP +
        '. ' + variantTitle + ' rounded up to ' + snapped + '.'
      );
    } else {
      this._clearMessage();
    }

    inp.value = String(snapped);
    this.colorQtys[variantId] = snapped;
    this._update();
  };

  // ── ATC ──────────────────────────────────────────────────
  SIWSAnnivHatPicker.prototype._bindAtc = function () {
    if (!this._atcBtn) return;
    var self = this;
    this._atcBtn.addEventListener('click', function () { self._addToCart(); });
  };

  SIWSAnnivHatPicker.prototype._snapAllInputs = function () {
    var self = this;
    this._qtyGrid.querySelectorAll('.siws-anniv-hat__qty-input').forEach(function (inp) {
      self._validateAndSnap(inp);
    });
  };

  SIWSAnnivHatPicker.prototype._addToCart = function () {
    if (!this._atcBtn || this._atcBtn.disabled) return;

    this._snapAllInputs();
    if (this.pickerQty === 0) return;

    // SIWS CUSTOM: gate ATC on the same validation chain the button label uses
    // — single source of truth for inventory, per-variant min/step, combined-min,
    // and combined-step. Prevents Shopify 422 → "Something went wrong" fallback.
    var blocked = this._validationMessage();
    if (blocked) { this._showMessage(blocked); return; }

    var items = [];
    var self = this;
    Object.keys(this.colorQtys).forEach(function (vid) {
      var qty = self.colorQtys[vid];
      if (qty <= 0) return;
      items.push({ id: parseInt(vid, 10), quantity: qty });
    });
    if (items.length === 0) return;

    var originalText = this._atcBtn.textContent;
    this._atcBtn.disabled    = true;
    this._atcBtn.textContent = 'Adding…';
    this._clearMessage();

    var cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
    var body = {
      items: items,
      sections:     cart ? cart.getSectionsToRender().map(function (s) { return s.id; }) : ['cart-icon-bubble'],
      sections_url: window.location.pathname
    };

    fetch('/cart/add.js', {
      method:  'POST',
      headers: { 'Content-Type': 'application/json' },
      body:    JSON.stringify(body)
    })
      .then(function (res) {
        if (!res.ok) throw new Error('Cart add failed');
        return res.json();
      })
      .then(function (responseData) {
        if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          publish(PUB_SUB_EVENTS.cartUpdate, { source: 'siws-anniv-hat', cartData: responseData });
        }
        if (cart) {
          cart.renderContents(responseData);
        } else {
          // Page-mode — stay on PDP, refresh cart bubble.
          var newBubbleHTML = responseData.sections && responseData.sections['cart-icon-bubble'];
          var liveBubble = document.getElementById('cart-icon-bubble');
          if (newBubbleHTML && liveBubble) {
            var parsed = new DOMParser().parseFromString(newBubbleHTML, 'text/html');
            var inner = parsed.querySelector('.shopify-section');
            if (inner) liveBubble.innerHTML = inner.innerHTML;
          }
          // Clear picker state so a re-click can't double-add.
          self.colorQtys = {};
          self._qtyGrid.querySelectorAll('.siws-anniv-hat__qty-input').forEach(function (inp) {
            inp.value = '';
          });
          self._update();
        }
      })
      .catch(function (err) {
        if (window.console && console.error) console.error('SIWS: 250th Anniversary Hat ATC failed', err);
        self._atcBtn.disabled    = false;
        self._atcBtn.textContent = originalText;
        self._showMessage('Something went wrong — please try again.');
      });
  };

  // SIWS CUSTOM: Validation cascade — same shape as duck-camo-hats but with
  // the additional combined-must-be-%12 check, since this product's tier
  // prices land at 12-multiples only.
  SIWSAnnivHatPicker.prototype._validationMessage = function () {
    var pickerOnly = this.pickerQty;
    var cartOnly = this.cartHatQty;
    var total = pickerOnly + cartOnly;

    if (pickerOnly === 0 && cartOnly === 0) {
      return 'Add ' + SIWS_ANNIV_AGG_MIN + ' hats across colors to add to cart';
    }
    if (pickerOnly === 0 && cartOnly >= SIWS_ANNIV_AGG_MIN) {
      return 'Select hats to add';
    }
    if (pickerOnly === 0) {
      var need = SIWS_ANNIV_AGG_MIN - cartOnly;
      return 'Add ' + need + ' more (' + cartOnly + ' of ' + SIWS_ANNIV_AGG_MIN + ')';
    }

    // SIWS CUSTOM: inventory gate — block ATC if qty exceeds available stock
    var cards = this.el.querySelectorAll('.siws-anniv-hat__variant-card');
    for (var ic = 0; ic < cards.length; ic++) {
      var card = cards[ic];
      var vid = card.dataset.variantId;
      var avail = parseInt(card.dataset.inventory || '9999', 10);
      var policy = card.dataset.inventoryPolicy || 'deny';
      var inCart = (this.cartHatQtyByVariant && this.cartHatQtyByVariant[vid]) || 0;
      var requested = this.colorQtys[vid] || 0;
      var totalRequested = requested + inCart;
      if (policy === 'deny' && totalRequested > avail) {
        var remaining = Math.max(0, avail - inCart);
        return 'Only ' + remaining + ' ' + this._variantName(vid) +
               ' available — reduce quantity to continue';
      }
    }

    if (total < SIWS_ANNIV_AGG_MIN) {
      var more = SIWS_ANNIV_AGG_MIN - total;
      return 'Add ' + more + ' more (' + total + ' of ' + SIWS_ANNIV_AGG_MIN + ')';
    }

    // Per-variant: must be 0 or ≥ 3 AND %3.
    var entries = Object.keys(this.colorQtys).map(function (k) {
      return [k, this.colorQtys[k]];
    }, this);
    for (var i = 0; i < entries.length; i++) {
      var vid = entries[i][0];
      var qty = entries[i][1];
      if (qty > 0 && qty < SIWS_ANNIV_VARIANT_MIN) {
        return this._variantName(vid) + ' needs minimum ' + SIWS_ANNIV_VARIANT_MIN + ' (or 0)';
      }
    }
    for (var j = 0; j < entries.length; j++) {
      var vid2 = entries[j][0];
      var qty2 = entries[j][1];
      if (qty2 > 0 && qty2 % SIWS_ANNIV_STEP !== 0) {
        return this._variantName(vid2) + ' must be in multiples of ' + SIWS_ANNIV_STEP;
      }
    }

    // Combined-must-be-multiple-of-12 — final gate.
    if (total % SIWS_ANNIV_AGG_STEP !== 0) {
      var nextMultiple = Math.ceil(total / SIWS_ANNIV_AGG_STEP) * SIWS_ANNIV_AGG_STEP;
      var addMore = nextMultiple - total;
      return 'Add ' + addMore + ' more to reach ' + nextMultiple + ' (tier breakpoint)';
    }

    return '';
  };

  SIWSAnnivHatPicker.prototype._variantName = function (variantId) {
    var inp = this._qtyGrid && this._qtyGrid.querySelector(
      '.siws-anniv-hat__qty-input[data-variant-id="' + variantId + '"]'
    );
    return (inp && inp.dataset.variantTitle) || 'Color';
  };

  // ── State updates ────────────────────────────────────────
  SIWSAnnivHatPicker.prototype._update = function () {
    var sum = 0;
    for (var k in this.colorQtys) {
      if (Object.prototype.hasOwnProperty.call(this.colorQtys, k)) {
        sum += this.colorQtys[k] || 0;
      }
    }
    this.pickerQty = sum;
    this.totalQty  = this.pickerQty + this.cartHatQty;

    if (this._atcBtn) {
      var blocked = this._validationMessage();
      this._atcBtn.disabled    = blocked !== '';
      this._atcBtn.textContent = blocked || 'Add to Cart';
    }
    this._renderSummary();
    this._renderTierCallout();
  };

  // Per-variant summary box, only rows where qty > 0. Uses base $20/each
  // for line display (Shopify cart applies the tier discount; PDP preview
  // is reconciled in the tier message below).
  SIWSAnnivHatPicker.prototype._renderSummary = function () {
    if (!this._summaryEl) return;
    if (this.pickerQty === 0) {
      this._summaryEl.hidden = true;
      this._summaryEl.innerHTML = '';
      return;
    }

    // SIWS CUSTOM 2026-05-27 PDP polish round 4 — thumb-click trigger + tier-aware
    // per-line summary math: perEach reads the combined-tier band (cart + picker)
    // via siwsAnnivPerEachFor. Below 12 totalQty: $20 (tier not qualified);
    // 12-23: $20 (base tier); 24-47: $17.916…; 48+: $16.145… All lines AND the
    // Total now use the SAME perEach — lines sum to Total at every qty band.
    // Replaces the prior $50-phantom-math (hardcoded $20 lines + tier-aware
    // proportional-split total) caught by the Chrome agent comparison.
    var perEach = siwsAnnivPerEachFor(this.totalQty);
    var self = this;
    var rowsHtml = [];
    this._qtyGrid.querySelectorAll('.siws-anniv-hat__variant-card').forEach(function (card) {
      var vid = card.dataset.variantId;
      var qty = self.colorQtys[vid] || 0;
      if (qty <= 0) return;
      var labelEl = card.querySelector('.siws-anniv-hat__variant-label');
      var title = labelEl ? labelEl.textContent : 'Color';
      var lineCost = qty * perEach;
      rowsHtml.push(
        '<tr>' +
          '<td>' + title + '</td>' +
          '<td class="siws-anniv-hat__summary-qty-cell">' +
            qty + ' &times; ' + siwsAnnivFmt(perEach) +
            ' = ' + siwsAnnivFmt(lineCost) +
          '</td>' +
        '</tr>'
      );
    });

    // Total = sum of lines (same perEach used per-line and here, so they match).
    var displayTotal = this.pickerQty * perEach;
    var unitLabel = this.pickerQty === 1 ? 'Hat' : 'Hats';

    this._summaryEl.innerHTML =
      '<h4 class="siws-anniv-hat__summary-title">Adding to Cart</h4>' +
      '<table class="siws-anniv-hat__summary-table">' +
        '<tbody>' + rowsHtml.join('') + '</tbody>' +
        '<tfoot>' +
          '<tr class="siws-anniv-hat__summary-total-row">' +
            '<td>Total</td>' +
            '<td class="siws-anniv-hat__summary-qty-cell">' +
              this.pickerQty + ' ' + unitLabel + ' &middot; ' + siwsAnnivFmt(displayTotal) +
            '</td>' +
          '</tr>' +
        '</tfoot>' +
      '</table>';
    this._summaryEl.hidden = false;
  };

  // SIWS CUSTOM 2026-05-27 PDP polish round 2 — Duck Camo pattern parity:
  // Tier-progress callout. Ports the duck-camo-hats __callout component
  // (assets/duck-camo-hats-picker.js _renderTierCallout, lines 447-518)
  // with Anniversary's tier values (12=$20, 24=$17.92, 48+=$16.15) and
  // amber below-min state instead of duck-camo's gray plain hint.
  //
  // Tier table inline — per-each rounded to cents from the canonical
  // fixed-total prices (240/12, 430/24, 775/48).
  SIWSAnnivHatPicker.prototype._renderTierCallout = function () {
    if (!this._tierCalloutEl) return;
    var total = this.totalQty;
    var calloutEl = this._tierCalloutEl;

    if (total === 0) {
      calloutEl.innerHTML = '';
      calloutEl.hidden = true;
      return;
    }
    calloutEl.hidden = false;

    // Below the 12-hat minimum — amber box, no progress bar. Anniversary
    // diverges from duck-camo's plain gray hint per David's spec ("box is
    // amber"). Same structural shape as duck-camo's __callout so the
    // CSS substrate handles both states.
    if (total < SIWS_ANNIV_AGG_MIN) {
      var needed = SIWS_ANNIV_AGG_MIN - total;
      calloutEl.innerHTML =
        '<div class="siws-anniv-hat__callout siws-anniv-hat__callout--warn">' +
          '<span class="siws-anniv-hat__callout-icon">⚠</span>' +
          '<div class="siws-anniv-hat__callout-text">' +
            '<p class="siws-anniv-hat__callout-primary">Add ' + needed + ' more to meet the 12-hat minimum</p>' +
          '</div>' +
        '</div>';
      return;
    }

    // SIWS CUSTOM 2026-05-27 PDP polish round 4 — DRY tier math via the shared
    // siwsAnnivPerEachFor helper. Same rates _renderSummary uses for per-line
    // and total; single source of truth.
    var perEach = siwsAnnivPerEachFor(total);
    var nextMin, nextPerEach, maxTierMin = 48;
    if (total >= 48) {
      nextMin = null;
    } else if (total >= 24) {
      nextMin = 48;
      nextPerEach = siwsAnnivPerEachFor(48);
    } else {
      nextMin = 24;
      nextPerEach = siwsAnnivPerEachFor(24);
    }

    // Max tier (48+) — green --max callout, no nudge, bar full.
    if (nextMin === null) {
      calloutEl.innerHTML =
        '<div class="siws-anniv-hat__callout siws-anniv-hat__callout--max">' +
          '<span class="siws-anniv-hat__callout-icon">🎉</span>' +
          '<div class="siws-anniv-hat__callout-text">' +
            '<p class="siws-anniv-hat__callout-primary">' + siwsAnnivFmt(perEach) + '/Each — ' + total + ' Hats</p>' +
            '<p class="siws-anniv-hat__callout-secondary">Best volume pricing unlocked</p>' +
            '<div class="siws-anniv-hat__callout-progress" ' +
                 'style="display:block;width:100%;height:14px;' +
                        'background:#d1d5db;border-radius:7px;' +
                        'overflow:hidden;margin-top:8px;">' +
              '<div class="siws-anniv-hat__callout-progress-bar" ' +
                   'style="display:block;height:14px;background:#16a34a;width:100%;"></div>' +
            '</div>' +
            '<p class="siws-anniv-hat__callout-progress-label">' + total + ' / ' + maxTierMin + '</p>' +
          '</div>' +
        '</div>';
      return;
    }

    // Active tier (12-47) — green callout with progress bar. Bar fills
    // toward nextMin (24 in the 12-tier; 48 in the 24-tier) per David's
    // spec ("progress bar fills toward 24" / "progress bar fills toward 48").
    // Note: this differs from duck-camo's cumulative-to-max bar (their bar
    // always references the top of the ladder); Anniversary uses
    // tier-relative-to-next per spec.
    var remaining = nextMin - total;
    var progressPct = Math.min((total / nextMin) * 100, 100);
    calloutEl.innerHTML =
      '<div class="siws-anniv-hat__callout">' +
        '<span class="siws-anniv-hat__callout-icon">↑</span>' +
        '<div class="siws-anniv-hat__callout-text">' +
          '<p class="siws-anniv-hat__callout-primary">' + siwsAnnivFmt(perEach) + '/Each — ' + total + ' Hats</p>' +
          '<p class="siws-anniv-hat__callout-secondary">Add ' + remaining + ' More For ' + siwsAnnivFmt(nextPerEach) + '/Each</p>' +
          '<div class="siws-anniv-hat__callout-progress" ' +
               'style="display:block;width:100%;height:14px;' +
                      'background:#d1d5db;border-radius:7px;' +
                      'overflow:hidden;margin-top:8px;">' +
            '<div class="siws-anniv-hat__callout-progress-bar" ' +
                 'style="display:block;height:14px;background:#16a34a;width:' + progressPct.toFixed(1) + '%;"></div>' +
          '</div>' +
          '<p class="siws-anniv-hat__callout-progress-label">' + total + ' / ' + nextMin + '</p>' +
        '</div>' +
      '</div>';
  };

  // ── Inline messages ──────────────────────────────────────
  SIWSAnnivHatPicker.prototype._showMessage = function (msg) {
    if (!this._msgEl) return;
    this._msgEl.textContent   = msg;
    this._msgEl.style.display = 'block';
  };
  SIWSAnnivHatPicker.prototype._clearMessage = function () {
    if (!this._msgEl) return;
    this._msgEl.style.display = 'none';
  };

  function siwsAnnivInit() {
    document.querySelectorAll('.siws-anniv-hat__container').forEach(function (el) {
      new SIWSAnnivHatPicker(el);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', siwsAnnivInit);
  } else {
    siwsAnnivInit();
  }
})();
